import { createRouter, createWebHistory } from 'vue-router';
import PackagePageVue from '@/modules/package/PackagePage.vue';
import PackageDetailPageVue from '@/modules/package-detail/PackageDetailPage.vue';
import HowToPurchasePage from '@/modules/how-to-purchase/HowToPurchasePage.vue';
import InvoicePage from '@/modules/package-detail/InvoicePage.vue';

const routes = [
    {
        path: '/',
        name: 'Package',
        component: PackagePageVue,
    },
    {
        path: '/lihat-paket-belajar',
        name: 'PackageView',
        component: PackagePageVue,
    },
    {
        path: '/detail-paket-belajar',
        name: 'PackageDetail',
        component: PackageDetailPageVue,
    },
    {
        path: '/cara-pembelian',
        name: 'HowToPurchase',
        component: HowToPurchasePage,
    },
    {
        path: '/invoice-pembelian',
        name: 'InvoicePembelian',
        component: InvoicePage,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
});

export default router;
